/**
 * Profit And Loss Reference Formatter.
 */
window.profitAndLossReferenceFormatter = function(value, row) {
    let html = '';
    switch (row.type) {
        case 'sales_invoice':
            html += '<a href="'+route('admin.sales.invoices.show', row.id)+'" target="_blank">'+value+'</a>';
            break;
        case 'purchase_invoice':
            html += '<a href="'+route('admin.purchase.invoices.show', row.id)+'" target="_blank">'+value+'</a>';
            break;
        default:
            html += value;
            break;
    }
    return html;
}